import { render, staticRenderFns } from "./BlankPresentation.vue?vue&type=template&id=c21c9722&scoped=true"
import script from "./BlankPresentation.vue?vue&type=script&lang=ts"
export * from "./BlankPresentation.vue?vue&type=script&lang=ts"
import style0 from "./BlankPresentation.vue?vue&type=style&index=0&id=c21c9722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21c9722",
  null
  
)

export default component.exports